import React from 'react'
import { observer } from 'mobx-react'
import SignInV2 from './SignInV2'

const PatientSignInPage = observer(() => {

    return <SignInV2 />


})
export default PatientSignInPage
